<div
    class="scrollable-container"
    *ngrxLet="{ isLeftScrollButtonDisabled: isLeftScrollButtonDisabled$, isRightScrollButtonDisabled: isRightScrollButtonDisabled$ } as vm"
>
    <button
        class="button-icon left-arrow"
        type="button"
        [disabled]="vm.isLeftScrollButtonDisabled"
        (click)="scrollLeft()"
        [attr.aria-disabled]="vm.isLeftScrollButtonDisabled"
        [attr.aria-label]="'dtmUi.carousel.previousSlideAriaLabel' | transloco"
    >
        <dtm-ui-icon name="arrow-left"></dtm-ui-icon>
    </button>
    <div
        class="scrollable-area"
        #scrollArea
        [dtmUiHorizontalScroll]="!vm.isLeftScrollButtonDisabled || !vm.isRightScrollButtonDisabled"
        dtmUiScrollTracker
        (scrollTrack)="changeScrollButtonState($event)"
    >
        <ng-container [ngSwitch]="activeLanguage$ | ngrxPush">
            <img *ngSwitchCase="'en'" ngSrc="assets/images/kpo/ck_en.svg" height="420" width="1148" alt="" />
            <img *ngSwitchDefault ngSrc="assets/images/kpo/ck_pl.svg" height="420" width="1148" alt="" />
        </ng-container>
    </div>
    <button
        class="button-icon right-arrow"
        type="button"
        [disabled]="vm.isRightScrollButtonDisabled"
        (click)="scrollRight()"
        [attr.aria-disabled]="vm.isRightScrollButtonDisabled"
        [attr.aria-label]="'dtmUi.carousel.nextSlideAriaLabel' | transloco"
    >
        <dtm-ui-icon name="arrow-right"></dtm-ui-icon>
    </button>
</div>
